import { render, staticRenderFns } from "./TopUserMenu.vue?vue&type=template&id=95c0a9f0&scoped=true&"
import script from "./TopUserMenu.vue?vue&type=script&lang=js&"
export * from "./TopUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./TopUserMenu.vue?vue&type=style&index=0&id=95c0a9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0a9f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VIcon,VList,VListItem,VListItemTitle,VMenu})
